import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
    selectReceiptId,
    selectReceipt,
} from "../../../redux/slices/receiptSlice";
import ReceiptDetails from "./ReceiptDetails";

const ConnectedReceiptDetails = ({ controlId }) => {
    const receiptId = useSelector(selectReceiptId);
    const receipt = useSelector(selectReceipt);

    const {
        transaction: { originalTransactionFee = 0.0 },
    } = receipt;

    const showTotal = originalTransactionFee !== 0;

    const receiptDetailsProps = {
        receiptId,
        controlId,
        showTotal,
    };

    return <ReceiptDetails {...receiptDetailsProps} />;
};

ConnectedReceiptDetails.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptDetails;
